import { AloftDate, RecommendedCompsStatistics } from '@aloft/toolkit-shared';

import { CompSelectionProperty } from '../types.ts';
import { getStatusGroup } from './getStatusGroup.ts';

const monthsAgo = (date: AloftDate, today = AloftDate.today()) =>
  today.differenceInCalendarMonths(date);

export const calculateCompSelectionStatistics = (
  comps: CompSelectionProperty[],
): RecommendedCompsStatistics => ({
  listingsSoldCount: comps.filter((comp) => getStatusGroup(comp.mlsStatus) === 'sold').length,
  listingsActiveCount: comps.filter((comp) => getStatusGroup(comp.mlsStatus) === 'active').length,
  listingsPendingCount: comps.filter((comp) => getStatusGroup(comp.mlsStatus) === 'pending').length,
  last3MonthsListingsCount: comps.filter(
    (comp) =>
      getStatusGroup(comp.mlsStatus) === 'sold' &&
      comp.saleDate &&
      monthsAgo(comp.saleDate) >= 0 &&
      monthsAgo(comp.saleDate) <= 3,
  ).length,
  last6MonthsListingsCount: comps.filter((comp) => {
    if (getStatusGroup(comp.mlsStatus) !== 'sold' || !comp.saleDate) return false;
    const months = monthsAgo(comp.saleDate);
    return months > 3 && months <= 6;
  }).length,
  last12MonthsListingsCount: comps.filter((comp) => {
    if (getStatusGroup(comp.mlsStatus) !== 'sold' || !comp.saleDate) return false;
    const months = monthsAgo(comp.saleDate);
    return months > 6 && months <= 12;
  }).length,
});
